var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.833 3.215a.952.952 0 00-.952.952v11.945l4.704-3.36a.714.714 0 01.83 0l4.704 3.36V4.167a.952.952 0 00-.952-.952H5.833zM4.15 2.483a2.38 2.38 0 011.683-.697h8.334a2.38 2.38 0 012.38 2.381V17.5a.714.714 0 01-1.129.582L10 14.212l-5.418 3.87a.714.714 0 01-1.13-.582V4.167c0-.631.251-1.237.698-1.683z",
    fill: "#fff"
  })));
}

export default SvgActionSave;